module.exports = "../images/icons/mail-contacts.svg";